export default __webpack_public_path__ + "static/media/underage.c71b3691.svg";